"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingService = void 0;
var base_service_1 = require("./base.service");
var insync_assess_sdk_1 = require("@greatmindsorg/insync-assess-sdk");
var api_constants_1 = require("../constants/api.constants");
var serializers_1 = require("./serializers");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var SettingService = /** @class */ (function (_super) {
    __extends(SettingService, _super);
    function SettingService(options, settingClient, settingsSerializer) {
        var _this = _super.call(this, options) || this;
        _this.settingClient = settingClient;
        _this.settingsSerializer = settingsSerializer;
        return _this;
    }
    SettingService.newInstance = function (options) {
        return new SettingService(options, insync_assess_sdk_1.SettingClient.newInstance({
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), new serializers_1.SettingSerializer(new serializers_1.OptionsSerializer(new serializers_1.PlayerOptionsSerializer(), new serializers_1.ScoreOptionsSerializer(), new serializers_1.ReportingOptionsSerializer(new serializers_1.SettingsPerformanceBandSerializer()), new serializers_1.AssessmentTypeOptionsSerializer(), new serializers_1.StandardsOptionsSerializer(new serializers_1.StandardSetSerializer()))));
    };
    SettingService.prototype.findByUserAndCurriculum = function (curriculum) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.settingClient.findByUserAndCurriculum(curriculum, this.getDefaultHeaders({ curriculumId: curriculum }))];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, this.settingsSerializer.serialize(data)];
                }
            });
        });
    };
    SettingService.prototype.createUserSetting = function (setting, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.settingClient.createUserSetting(setting, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SettingService.prototype.update = function (settingId, optionDto, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.settingClient.update(settingId, optionDto, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SettingService.prototype.findDistrictByCurriculumList = function (curriculums) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.settingClient.findDistrictByCurriculum(curriculums, this.getDefaultHeaders({ curriculumId: !(0, isEmpty_1.default)(curriculums) ? curriculums[0] : undefined }))];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.map(function (settingObj) { return _this.settingsSerializer.serialize(settingObj); })];
                }
            });
        });
    };
    SettingService.prototype.updateDistrictSettings = function (settings, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.settingClient.saveDistrictSetting(settings, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return SettingService;
}(base_service_1.BaseService));
exports.SettingService = SettingService;
